var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 13C4.0978 12.222 3.26156 11.3692 2.49999 10.4503C1.35714 9.07043 6.2778e-07 7.01539 6.2778e-07 5.0571C-0.000495013 4.05699 0.292506 3.07921 0.841922 2.2475C1.39134 1.4158 2.17247 0.76755 3.08647 0.384803C4.00047 0.00205556 5.00624 -0.0979864 5.9765 0.0973378C6.94676 0.292662 7.83789 0.774572 8.53712 1.48208C9.00266 1.95061 9.37165 2.50782 9.62275 3.12147C9.87385 3.73513 10.0021 4.39303 9.99998 5.0571C9.99998 7.01539 8.64284 9.07043 7.49998 10.4503C6.73841 11.3692 5.90217 12.222 4.99999 13ZM4.99999 2.89086C4.43167 2.89086 3.88663 3.11909 3.48476 3.52534C3.0829 3.93159 2.85714 4.48258 2.85714 5.0571C2.85714 5.63163 3.0829 6.18262 3.48476 6.58887C3.88663 6.99512 4.43167 7.22335 4.99999 7.22335C5.56831 7.22335 6.11335 6.99512 6.51521 6.58887C6.91708 6.18262 7.14284 5.63163 7.14284 5.0571C7.14284 4.48258 6.91708 3.93159 6.51521 3.52534C6.11335 3.11909 5.56831 2.89086 4.99999 2.89086Z",
    fill: "#23FF8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b3921a1aafa3263dd04a6892bd085a5f.svg";
export { ForwardRef as ReactComponent };